// @ts-nocheck
import { Handler } from "@insite/client-framework/HandlerCreator";
import { GetWishListApiParameter } from "@insite/client-framework/Services/WishListService";
import {
    chain,
    CreateDataForUnparse,
    GenerateCsv,
} from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/ExportWishList";
import translate from "@insite/client-framework/Translate";
import { WishListModel } from "@insite/client-framework/Types/ApiModels";
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";
import xlsx from "xlsx";

type HandlerType = Handler<
    { wishListId: string },
    {
        apiParameter: GetWishListApiParameter;
        apiResult: WishListModel;
        pricingLoaded?: true;
        dataForUnparse: { fields: Array<any>; data: string | Array<any> };
    }
>;
// reference: https://github.com/SheetJS/sheetjs/issues/1339, added typing and formatting params
export const formatColumn = (worksheet: xlsx.WorkSheet, col: number, format: Record<string, any>) => {
    const range = xlsx.utils.decode_range(worksheet?.["!ref"] || "");
    // note: range.s.r + 1 skips the header row
    for (let row = range.s.r + 1; row <= range.e.r; ++row) {
        const ref = xlsx.utils.encode_cell({ r: row, c: col });
        if (worksheet[ref]) {
            Object.assign(worksheet[ref], format);
        }
    }
};
export const formatExcelOutput = (workSheet: xlsx.WorkSheet, fields: string[]) => {
    workSheet["!cols"] = [] as xlsx.ColInfo[];
    fields.forEach((field: string) => {
        if (field === translate("MFG #")) {
            workSheet["!cols"]?.push({ width: 15 });
            return;
        }
        if (field === translate("Title")) {
            workSheet["!cols"]?.push({ width: 100 });
            return;
        }
        if (field === translate("Added on")) {
            workSheet["!cols"]?.push({ width: 15 });
            return;
        }
        workSheet["!cols"]?.push({ width: 10 });
    });
    const mfgIndex = fields.indexOf(translate("MFG #"));
    const addedOnIndex = fields.indexOf(translate("Added on"));
    formatColumn(workSheet, mfgIndex, { t: "s" });
    formatColumn(workSheet, addedOnIndex, { t: "d", z: "mm/dd/yyyy" });
};

export const GenerateXLSXHandler =
    (fileNamePrefix: string): HandlerType =>
    props => {
        if (!props.dataForUnparse || typeof props.dataForUnparse.data === "string") {
            return;
        }

        const rows = [[...props.dataForUnparse.fields], ...props.dataForUnparse.data];
        const workbook = xlsx.utils.book_new();
        const workSheet = xlsx.utils.aoa_to_sheet(rows);
        xlsx.utils.book_append_sheet(workbook, workSheet, `${fileNamePrefix} data`);
        formatExcelOutput(workSheet, props.dataForUnparse.fields);
        const wishListName = props.apiResult.name.replace(/[/\\?%*:|"<>]/g, "-").substring(0, 40);
        const fileName = `${fileNamePrefix}_${wishListName}.xlsx`;
        xlsx.writeFile(workbook, fileName, { cellStyles: true });
    };

// changing order of the fields to match order upload
export const CreateDataForUnparseWithUpload: HandlerType = props => {
    const { wishListLineCollection } = props.apiResult;
    if (!wishListLineCollection?.length) {
        return;
    }

    props.dataForUnparse = {
        fields: [
            translate("Item #"),
            translate("Quantity"),
            translate("Unit of Measure"),
            translate("MFG #"),
            translate("Brand"),
            translate("Title"),
            translate("Price"),
            translate("Notes"),
            translate("Added on"),
            translate("Added by"),
        ],
        data: wishListLineCollection.map(o => [
            o.erpNumber,
            o.qtyOrdered.toString(),
            o.unitOfMeasure,
            o.manufacturerItem.toString(),
            o.brand?.name || "",
            o.shortDescription,
            o.quoteRequired ? "" : o.pricing?.unitRegularPrice?.toString() || "",
            o.notes,
            o.createdOn.toString(),
            o.createdByDisplayName,
        ]),
    };
};
replaceInChain(chain, CreateDataForUnparse, CreateDataForUnparseWithUpload);
replaceInChain(chain, GenerateCsv, GenerateXLSXHandler("MyList"));
